import { render, staticRenderFns } from "./JobPreviewFreeTopicsSp.vue?vue&type=template&id=005d068b&scoped=true"
import script from "./JobPreviewFreeTopicsSp.vue?vue&type=script&lang=js"
export * from "./JobPreviewFreeTopicsSp.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewFreeTopicsSp.vue?vue&type=style&index=0&id=005d068b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d068b",
  null
  
)

export default component.exports